<template>
  <div class="enroll-auth-page">
    <div class="bg-shape shape-a"></div>
    <div class="bg-shape shape-b"></div>
    <el-card class="auth-card">
      <template #header>
        <div class="card-header">
          <h2>自主招生登录</h2>
          <p>上海市实验学校东滩高级中学</p>
        </div>
      </template>

      <el-form :model="form" label-position="top" @submit.prevent="handleLogin">
        <el-form-item label="身份证件号">
          <el-input v-model="form.id_card" placeholder="请输入身份证件号" />
        </el-form-item>
        <el-form-item label="密码">
          <el-input
            v-model="form.password"
            type="password"
            show-password
            placeholder="请输入密码"
            @keyup.enter="handleLogin"
          />
        </el-form-item>

        <el-button class="submit-btn" type="primary" :loading="loading" @click="handleLogin">
          登录
        </el-button>
        <el-button class="ghost-btn" @click="router.push('/enroll/register')">
          去注册
        </el-button>
      </el-form>
    </el-card>
  </div>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import { enrollmentStudentApi } from '@/api'
import { setEnrollToken, setEnrollUser } from '@/utils/auth'

const router = useRouter()
const loading = ref(false)
const form = reactive({
  id_card: '',
  password: ''
})

const handleLogin = async () => {
  if (!form.id_card || !form.password) {
    ElMessage.warning('请输入身份证件号和密码')
    return
  }

  loading.value = true
  try {
    const data = await enrollmentStudentApi.login(form)
    setEnrollToken(data.access_token)
    setEnrollUser(data.student)
    ElMessage.success('登录成功')
    router.replace('/enroll/form')
  } finally {
    loading.value = false
  }
}
</script>

<style scoped>
.enroll-auth-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background:
    radial-gradient(circle at 15% 20%, rgba(56, 189, 248, 0.2), transparent 30%),
    radial-gradient(circle at 82% 15%, rgba(59, 130, 246, 0.18), transparent 32%),
    linear-gradient(145deg, #eff6ff 0%, #f0f9ff 42%, #ecfeff 100%);
  padding: 20px;
  position: relative;
  overflow: hidden;
}

.auth-card {
  width: 100%;
  max-width: 460px;
  border-radius: 18px;
  border: 1px solid rgba(191, 219, 254, 0.7);
  box-shadow: 0 20px 45px rgba(30, 64, 175, 0.12);
  backdrop-filter: blur(6px);
  position: relative;
  z-index: 1;
}

.bg-shape {
  position: absolute;
  border-radius: 999px;
}

.shape-a {
  width: 260px;
  height: 260px;
  background: rgba(56, 189, 248, 0.2);
  top: -90px;
  left: -80px;
}

.shape-b {
  width: 280px;
  height: 280px;
  background: rgba(59, 130, 246, 0.12);
  right: -100px;
  bottom: -120px;
}

.card-header {
  text-align: center;
}

.card-header h2 {
  font-size: 26px;
  color: #0b3a73;
  letter-spacing: 0.5px;
}

.card-header p {
  color: #64748b;
  margin-top: 6px;
}

:deep(.auth-card .el-form-item__label) {
  font-weight: 600;
  color: #334155;
}

.submit-btn,
.ghost-btn {
  width: 100%;
  margin-top: 8px;
}
</style>
